IREP.HackAndSlash = (function () {

    var sHeight = 0;
    var hHeight = 0;

    var init = function () { }

    var regSetup = function (selectText, congratsHackText, congratsSlashText, sorryChipText, sorryTierText) {
        $("body").addClass("HackAndSlashBackground");

        // Setup Hack btn events
        $("#btnHack").on("mouseover", function () {
            if (hHeight == 0) {
                hHeight = $("#charHack").height();
            }
            $("#btnSlash").animate({ opacity: 0.3 }, 250);
            $("#charSlash").animate({ opacity: 0.6 }, 250);
            $("#charHack").animate({ height: hHeight+50 }, 250);
            $("#btnHack").html(selectText);
        });
        $("#btnHack").on("mouseout", function () {
            $("#btnSlash, #charSlash").animate({ opacity: 1.0 }, 250);
            $("#btnHack").html("&nbsp;");
            $("#charHack").animate({ height: hHeight}, 250);
        });
        $("#btnHack").one("click", function () {
            if ((IREP.options.user.tier >= 3 && IREP.options.user.site == "LAR") || (IREP.options.user.tier >= 4 && IREP.options.user.site == "APAC")) {
                if (IREP.options.user.chipCount >= 500) {

                    IREP.callApi("hackandslash/pickteam", "POST", { Team: "TEAMHACK" }).done(function () { });

                    $(".registrationDetails").html(congratsHackText);
                    $(".registrationDetails").addClass("registrationSuccess");
                    $("#btnSlash").off("click");
                    $("#btnSlash, #btnHack").off("mouseout");
                    $("#btnSlash, #btnHack").off("mouseover");
                } else {
                    $(".registrationDetails").html(sorryChipText);
                    $(".registrationDetails").addClass("registrationError");
                }
            } else {
                $(".registrationDetails").html(sorryTierText);
                $(".registrationDetails").addClass("registrationError");
            }
        });
        // Setup Slash btn events
        $("#btnSlash").on("mouseover", function () {
            if (sHeight == 0) {
                sHeight = $("#charSlash").height();
            }
            $("#btnHack").animate({ opacity: 0.3 }, 250);
            $("#charHack").animate({ opacity: 0.6 }, 250);
            $("#charSlash").animate({ height: sHeight + 50 }, 250);
            $("#btnSlash").html(selectText);
        });
        $("#btnSlash").on("mouseout", function (e) {
            $("#btnHack, #charHack").animate({ opacity: 1.0 }, 250);
            $("#btnSlash").html("&nbsp;");
            $("#charSlash").animate({ height: sHeight }, 250);
        });
        $("#btnSlash").one("click", function () {
            if (IREP.options.user.tier > 3) {
                if (IREP.options.user.chipCount >= 500) {

                    IREP.callApi("hackandslash/pickteam", "POST", {Team: "TEAMSLASH"}).done(function () {});

                    $(".registrationDetails").html(congratsSlashText);
                    $(".registrationDetails").addClass("registrationSuccess");
                    $("#btnHack").off("click");
                    $("#btnSlash, #btnHack").off("mouseout");
                    $("#btnSlash, #btnHack").off("mouseover");
                } else {
                    $(".registrationDetails").html(sorryChipText);
                    $(".registrationDetails").addClass("registrationError");
                }
            } else {
                $(".registrationDetails").html(sorryTierText);
                $(".registrationDetails").addClass("registrationError");
            }           
        });
    }

    var activateHack = function () {
        $("body").addClass("HackAndSlashBackground");

        $("#btnSlash").animate({ opacity: 0.3 }, 250);
        $("#charSlash").animate({ opacity: 0.6 }, 250);
        //$("#btnHack").html("I choose Hack!");
    }

    var activateSlash = function () {
        $("body").addClass("HackAndSlashBackground");

        $("#btnHack").animate({ opacity: 0.3 }, 250);
        $("#charHack").animate({ opacity: 0.6 }, 250);
        //$("#btnSlash").html("I choose Slash!");
    }


    var hub = null;
    var hackScore = 0;
    var slashScore = 0;
    var myTeam = "";
    var discoPartyActive = 0;
    var isHSMobile = false;
    
    var dungeon = function (tm, mobile) {
        myTeam = tm;
        isHSMobile = mobile;
        if (isHSMobile == true) {
            $("body").addClass("HackAndSlashDungeonMobileBackground");
        } else {
            $("body").addClass("HackAndSlashDungeonBackground");
        }
        
        $("#charSlash").animate({ left: "750px" }, 2000);
        $("#charHack").animate({ left: "-260px" }, 2000);
        $(".miniTokens img").on("click", function () {
            $(".detailLarge img").attr("src", "/content/images/hackandslash/tokens-large-txt/token-" + $(this).data("token") + ".png");
            $(".tokenHeaderName").html($(this).data("title"));
            $(".miniHeader").html($(this).data("description"));
        });

        $(".overviewButton").on("click", function () {
            $(".overviewDetails").animate({ top: "50px" }, 1500);
        });

        $(".overviewDetails .closeButton").on("click", function () {
            $(".overviewDetails").animate({ top: "-870px" }, 1500);
        });

        hub = $.connection.hackAndSlashHub;
        hub.client.tokenRedeemed = function (t) {
            $("#currentToken img").attr("src", "/content/images/hackandslash/tokens-large-txt/token-" + t.Token + ".png");
            $("#currentToken img").removeClass("movestuff");
            setTimeout(function () { $("#currentToken img").addClass("finishMoving"); }, 1);

            if (isHSMobile)
            {
                $(".tokenDescName").hide();
                $(".tokenDescAttr").hide();
                $(".currentTokenDetails").show();
                $("." + t.Token).show();
            }

            hub.server.tokensAvailable()
        }
        hub.client.setStartingScore = function (scores) {
            hackScore = scores.Hack;
            slashScore = scores.Slash;
            $("#hackDetails .team .score").html(scores.Hack);
            $("#slashDetails .team .score").html(scores.Slash);
            animateMeters();
        }

        hub.client.setCurrentTokens = function (t) {
            $("#currentCount").html(t);

            if (t > 0) {
                $("#playToken .buttonContainer").css("visibility", "visible");

                $("#playTokenButton").one("click", function () {
                    $("#currentCount").html(parseInt($("#currentCount").html()) - 1);
                    $("#playToken .buttonContainer").css("visibility", "hidden");
                    $("#currentToken img").removeClass("movestuff");
                    $("#currentToken img").removeClass("finishMoving");
                    setTimeout(function () { $("#currentToken img").addClass("movestuff"); }, 1);
                    hub.server.redeemToken();
                    
                })
            }
        }

        hub.client.setupBattleLog = function (b) {
            $(b).each(function () {
                $("#battleLogItems").append("<div class='" + this.Team + "'>" + this.Player + "&nbsp;&nbsp;" + getFormattedScore(this.Score) + " " + getScoreCharacter(this.Score, this.Team) + "<img src='/content/images/hackandslash/token-icons-sm/token-" + this.Token + "-icon-sm.png'/></div>");
                if ((getScoreCharacter(this.Score, this.Team) == "HACK") && ($("#mostRecentHack .container div").length <= 4)) {
                    $("#mostRecentHack .container").append("<div class='" + getTextClass(b.Token) + "' style=\"background:url('/content/images/hackandslash/token-icons-lg/token-" + this.Token + "-icon-lg.png') no-repeat center right;\">" + getFormattedScore(this.Score) + "</div>");
                }
                else if ((getScoreCharacter(this.Score, this.Team) == "SLASH") && ($("#mostRecentSlash .container div").length <= 4)) {
                    $("#mostRecentSlash .container").append("<div class='" + getTextClass(b.Token) + "' style=\"background:url('/content/images/hackandslash/token-icons-lg/token-" + this.Token + "-icon-lg.png') no-repeat center left;\">" + getFormattedScore(this.Score) + "</div>");
                }
            });
        }

        hub.client.newBattleItem = function (b) {
            $("#battleLogItems").prepend("<div class='" + b.Team + "'>" + b.Player + "&nbsp;&nbsp;" + getFormattedScore(b.Score) + " " + getScoreCharacter(b.Score, b.Team) + "<img src='/content/images/hackandslash/token-icons-sm/token-" + b.Token + "-icon-sm.png'/></div>");
            if ($("#battleLogItems div").length > 100) {
                $($("#battleLogItems div")[100]).remove();
            }
            
            if (getScoreCharacter(b.Score, b.Team) == "HACK") {
                $("#mostRecentHack .container").prepend("<div class='" + getTextClass(b.Token) + "' style=\"background:url('/content/images/hackandslash/token-icons-lg/token-" + b.Token + "-icon-lg.png') no-repeat center right;\">" + getFormattedScore(b.Score) + "</div>");
                if($("#mostRecentHack .container div").length > 4)
                {
                    $($("#mostRecentHack .container div")[4]).remove();
                }
                hackScore = hackScore + b.Score;
                $("#hackDetails .team .score").html(hackScore);

            } else if (getScoreCharacter(b.Score, b.Team) == "SLASH") {
                $("#mostRecentSlash .container").prepend("<div class='" + getTextClass(b.Token) + "' style=\"background:url('/content/images/hackandslash/token-icons-lg/token-" + b.Token + "-icon-lg.png') no-repeat center left;\">" + getFormattedScore(b.Score) + "</div>");
                if ($("#mostRecentSlash .container div").length > 4) {
                    $($("#mostRecentSlash .container div")[4]).remove();
                }
                slashScore = slashScore + b.Score;
                $("#slashDetails .team .score").html(slashScore);
            }
            animateMeters();
        }

        hub.client.discoPartyTime = function (d) {
            if (d.Team == myTeam && discoPartyActive == 0) {
                discoPartyActive = 1;
                $("#Dungeon").prepend("<img class='discoBall' src='/content/images/hackandslash/disco_ball.gif'/>");
                $("#Dungeon").prepend("<div class='discoLights'><div class='movableLights'></div></div>");
                $(".discoBall").animate({ top: "-100px" }, 3000, function () {
                    $(".discoLights").fadeIn();
                    //animateLights();
                    setTimeout(function () { discoIsDead(); }, d.Time);

                });

                $("body").append("<audio id='sndDisco' src='/Content/Images/HackAndSlash/discoParty.wav' loop='loop'></audio>");
                $(".game").prepend("<div class='soundButton'></div>");

                document.getElementById("sndDisco").play();

                $(".soundButton").on("click", function () {
                    if (document.getElementById("sndDisco").paused) {
                        document.getElementById("sndDisco").play();
                        $(".soundButton").css("background", "url('/content/images/hackandslash/button-mute.png') no-repeat");
                    } else {
                        document.getElementById("sndDisco").pause();
                        $(".soundButton").css("background", "url('/content/images/hackandslash/button-un-mute.png') no-repeat");
                    }
                });
            }
        }

        hub.client.allowDailyFeud = function () {
            setupDailyChallenge();
        }

        $.connection.hub.qs = { paxuid: IREP.options.user.currentUID }
        $.connection.hub.start({}, function (s) {});
    }

    var discoIsDead = function () {
        $(".discoLights").fadeOut(500, function () { $(".discoLights").remove(); });
        $(".discoBall").animate({ top: "-400px" }, 1000, function () { $(".discoBall").remove(); });
        discoPartyActive = 0;
        $(".soundButton").fadeOut();
        document.getElementById("sndDisco").pause();
        $("#sndDisco").remove();
    }

    var animateLights = function () {
        $(".discoLights").css("left","500px").css("width", ($("body").width() * 2).toString() + "px");
        $(".discoLights").animate({left:"-500px"}, 10000, function(){animateLights();})
    }

    var getFormattedScore = function (s) {
        if (s > 0) {
            return "+" + s;
        }

        return s;
    }

    var animateMeters = function () {
        var total = Math.abs(hackScore) + Math.abs(slashScore);
        if(hackScore > 0){
            $("#hackMeter .progress").animate({ height: (Math.min(Math.max((hackScore / total),.15), .83) * 100) + "%" }, 500);
        }

        if (slashScore > 0)
        {
            $("#slashMeter .progress").animate({ height: (Math.min(Math.max((slashScore / total), .15), .83) * 100) + "%" }, 500);
        }
    }

    var getTextClass = function (t) {
        switch(t)
        {
            case "disco-ball":
                return "textPink";
            case "elixer-of-healing":
            case "lightning-bolt":
            case "sandwich":
            case "swamp-water":
            case "donut-with-sprinkles":
                return "textOrange";
            default:
                return "";
                break;
        }
    }

    var getScoreCharacter = function (a, b) {
        if (a > 0)
        {
            return b;
        } else {
            if (b == "SLASH") {
                return "HACK";
            } else {
                return "SLASH";
            }
        }

    }

    var setupDailyChallenge = function () {
        $("#dailyChallenge").slideDown();

        


        $("#activateChallenge").on("click",
        function () {

            var quizMask = 'dungeon-mask'
            if (isHSMobile) {
                quizMask = 'dungeon-maskmobile'
            }

            IREP.callApi({
                url: "quiz",
                type: "GET",
                data: {
                    activityCode: "201503quiz_HackvSlash"
                }
            }).done(function (d) {
                var options = $.extend({}, d, { quizSelector: '#contentContainer, #footer, #header, #mobileAppContainer', quizBodyClass: "quizDungeon", returnUrl: "javascript:window.location=window.location.href", mask: quizMask, isMobile: isHSMobile, "apiRoot": "https://retailedge.intel.com/api/", "appRoot": "/50/" })
                IREP.quiz = new IREP.Quiz(options);
                IREP.quiz.startQuiz();
                if (!isHSMobile) {
                    //$(".dungeon-mask").prepend("<div class='battleInfo" + myTeam + "'></div><img class='opponent" + myTeam + "' src='/content/images/hackandslash/battle" + myTeam + "Opponent.png'/>");
                } else {
                    $(".quizDungeon").addClass("quizDungeonMobile");
                }

                $(IREP.quiz).on("irep.quiz.results", function (e, result) {
                    if (result.pass) {
                        setTimeout(function () {
                            $(".actions").prepend("<div class='resultDetails'><img src='/Content/Images/HackAndSlash/token-plus-one.png' style='height:160px;width:160px;'/></div>");
                        }, 2000);
                    } else {
                        setTimeout(function () {
                            $(".actions").prepend("<div class='resultDetails'></div>");
                        }, 2000);
                    }
                });
            });
        });
    }

    var visitor = function () {
        IREP.callApi("/hackandslash/visitor", "POST").done(function (d) { if (d.count == 1) { $(".overviewDetails").animate({ top: "50px" }, 1500); } });
    }

    //var releaseTheMango = function () {

    //    var options = { "activityUID": "EFD1BF1D-13D8-4C00-8857-24F927EC289F", "activityCode": "201411art-HackAndSlashGotCode", "activityType": "videoquiz", "apiRoot": "https://retailedge.intel.com/api/", "appRoot": "/50/", "cultureCode": "en-US", "paxUID": IREP.options.user.currentUID, "randomized": true, "displayLimit": 1, "startAutomatically": true, quizSelector: '#contentContainer, #footer, #header, #mobileAppContainer', quizBodyClass: "quizDungeon", returnUrl: "javascript:IREP.HackAndSlash.hideMango();", mask: "dungeon-mask", "text": { "correct": "Correct!", "incorrect": "Incorrect!", "return": "Close", "review": "Retake", "continue": "Continue", "multiselect": "Select all that apply" } };

    //    IREP.quiz = new IREP.Quiz(options);
    //    IREP.quiz.startQuiz();
        
    //}

    //var hideMango = function () {
    //    $('#contentContainer, #footer, #header').show();
    //    $('.dungeon-mask, .quizDungeon').hide();
    //}

    var tokenClicks = [];

    var activatePuzzle = function (d) {
        $(".miniTokens img").on("click", function () {
            $(".detailLarge img").attr("src", "/content/images/hackandslash/tokens-large-txt/token-" + $(this).data("token") + ".png");
            $(".tokenHeaderName").html($(this).data("title"));
            $(".miniHeader").html($(this).data("description"));
            tokenClicks.push($(this).data("token"));
            checkTokenList();
        });
    }

    var checkTokenList = function () {
        if (tokenClicks.length >= 6) {
            var str = "";
            var latestClicks = tokenClicks.slice(tokenClicks.length - 6);
            latestClicks.forEach(function (d) { str += d; });
            if (((str == "yellow-health-stardonut-with-sprinklespineapplemangoprincessmagical-orange-wafers") && (myTeam == "SLASH")) || ((str == "vhs-tapelightning-boltelixer-of-healingbattle-axefluffy-throw-pillowsandwich") && (myTeam == "HACK")))
            {
                IREP.callApi("hackandslash/sabt", "POST", { Code: "INBOXPUZZLE" });
                $("body").append("<div id='hackAndSlashBonusToken'></div>");
                $("#hackAndSlashBonusToken").animate({ "right": "0px" }, 1000);
                $("#hackAndSlashBonusToken").on("click", function () {
                    window.location = window.location.href;
                });

                
            }
        }
    }

    var track = function (code, type, label, value, data) {
        var myDate = new Date(Date.now());
        code = code + (myDate.getUTCMonth() + 1).toString() + "" + (myDate.getUTCDate()).toString() + (myDate.getUTCFullYear()).toString()

        IREP.callApi({ type: "POST", url: '/hackandslash/tracker', data: { code: code, type: type, label: label, value: value, data: data } }).done(
            function (data) 
            {
                //console.log(data);
                //if (data.activate)
                //{                    
                //    $("body").append("<div id='hackAndSlashBonusToken'></div>");
                //    $("#hackAndSlashBonusToken").animate({ "right": "0px" }, 1000);
                //    $("#hackAndSlashBonusToken").on("click", function () {
                //        window.location = IREP.options.appUrl.replace("/api/", IREP.options.appUrl) + "/hackandslash/dungeon";
                //    });
                //}
            });
    }

    return {
        init: init,
        regSetup: regSetup,
        activateHack: activateHack,
        activateSlash: activateSlash,
        dungeon: dungeon,
        visitor: visitor,
        //releaseTheMango: releaseTheMango,
        //hideMango: hideMango,
        activatePuzzle: activatePuzzle,
        track: track
    }
})();